import React, { useEffect, useState } from 'react'
import styled from 'styled-components'
import { tabletSize } from '../../../catalog/screen-sizes'

export const BannerBottom = () => {
  // a click handler on the <a> tag will before run aTrack() then redirect

  return (
    <Root>
      <Slider>
        <SliderText>
          Building v2 <Dot> ·</Dot> <b>100%</b>
        </SliderText>
      </Slider>
    </Root>
  )
}

const Root = styled.div`
  position: relative;
  left: 0;
  right: 0;
  bottom: 0;

  // inside component
  display: flex;
  flex-direction: row;
  justify-content: left;
  align-items: center;
  width: 100%;
  height: 56px;
  background-color: #d5ceff;
  //z-index: 2;
  @media (max-width: ${tabletSize}) {
    height: 40px;
  }
`

const Slider = styled.div`
  height: 100%;
  background-color: #5d4fdd;
  width: 100%;
  border-top-right-radius: 60px;
  border-bottom-right-radius: 60px;
  background: radial-gradient(circle 300px at bottom right, #9a8ce9, #5d4fdd);
`

const SliderText = styled.div`
  margin-left: 40px;
  font-size: 20px;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  height: 100%;
  color: white;
  @media (max-width: ${tabletSize}) {
    font-size: 18px;
  }
`

const Dot = styled.span`
  font-size: 2rem;
  margin-left: 20px;
  margin-right: 20px;
`
